import React from 'react'
import liveUiService from 'live/services/ui'
import AddOnImpl from 'live/api/add-on'
import onClickOutside from 'react-onclickoutside'
import i18n from 'live/services/i18n'
import { LiveApi } from 'live/lib/api'

import ServiceLocator from 'live/services/service-locator'
import timelineService from './services/timeline'
import annotationService from './services/annotation'
import TimelineProvider from './timeline/components/timeline-provider'
import Timeline from './timeline/components/timeline'
import TimelineViewMenu from './timeline/components/timeline-view-main-header-button'
import TimelineViewMenuDropdown from './timeline/components/timeline-view-main-header-dropdown-menu-button'
import TimelineModalConfig from './timeline/components/timeline-edition-modal-config'
import annotationFeedRenderBuilder from './annotations/annotation-feedrender-builder'
import AnnotationDefaultForm from './forms/annotation-default-form'
import permission from './services/permission'
import { TimelineEventRendererRegistry, TimelineFormRegistry } from './registries'
import registerWidgetForMarkers from './markers/registry'
import MarkerEventRenderer from './markers/components/AnnotationEventRenderer'
import MarkersSettings from './markers/settings'
import TimelineSettings from './timeline/settings'
import SettingsService from 'live/services/settings'

export const DefaultAnnotationFormConfigs: FormConfigs = {
    get shortTitle() {
        return i18n('NOTES')
    },
    get title() {
        return i18n('CREATE NOTE')
    },
    get editTitle() {
        return i18n('EDIT NOTE')
    },
    component: AnnotationDefaultForm
}

export default class Main {
    static start() {
        try {
            if (permission.canCreateAnnotations()) {
                ServiceLocator.registerService('timeline-form-registry', TimelineFormRegistry)
                ServiceLocator.getService('messenger-form-registry').then(reg =>
                    reg.register(DefaultAnnotationFormConfigs)
                )
            }

            ServiceLocator.registerService('annotation-service', annotationService)
            ServiceLocator.registerService('timeline-service', timelineService)

            TimelineEventRendererRegistry.register(MarkerEventRenderer('timeline'))
            const MessengerMarkerRenderer = MarkerEventRenderer('messenger')

            ServiceLocator.registerService('timeline-event-renderer-registry', TimelineEventRendererRegistry)
            ServiceLocator.getService('messenger-event-renderer-registry').then(ComponentFactoryRegistry => {
                ComponentFactoryRegistry.register(annotationFeedRenderBuilder)
                ComponentFactoryRegistry.register(MessengerMarkerRenderer)
            })

            // registers default-annotation on messenger feed
            ServiceLocator.getService('messenger-event-renderer-registry').then(reg => {
                reg.register(annotationFeedRenderBuilder)
                reg.register(MessengerMarkerRenderer)
            })

            const TimelineAddOn = new AddOnImpl(TimelineProvider(onClickOutside(Timeline), false), { order: 0 })
            const TimelineViewMenuAddOn = new AddOnImpl(TimelineViewMenu, { order: 1 })
            const TimelineViewMenuDropdownAddOn = new AddOnImpl(TimelineViewMenuDropdown, { order: 1 })
            const TimelineModalConfigAddOn = new AddOnImpl(TimelineProvider(TimelineModalConfig, true), { order: 1 })

            liveUiService.registerAddOn(liveUiService.uiSections.DASHBOARD_VIEW_UNDER_HEADER, TimelineAddOn)
            liveUiService.registerAddOn(liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER, TimelineViewMenuAddOn)
            liveUiService.registerAddOn(
                liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER_DROPDOWN_MENU,
                TimelineViewMenuDropdownAddOn
            )
            liveUiService.registerAddOn(
                liveUiService.uiSections.DASHBOARD_EDITION_MAIN_HEADER,
                TimelineModalConfigAddOn
            )

            const userPermissions = Live.authorization.Permission
            const permissions = [
                {
                    label: i18n('Edit Annotations'),
                    group: 'General',
                    hasAdditionalPermission: false,
                    viewPermission: userPermissions.EDIT_ANNOTATIONS
                }
            ]

            permissions.forEach(e => LiveApi.Extension.permissions.register(e))

            // Ruler creation capabilitites for widgets
            registerWidgetForMarkers('temporal')
            SettingsService.register(MarkersSettings)
            SettingsService.register(TimelineSettings)
            // registerWidgetForMarkers('channels-temporal')
            // registerWidgetForMarkers('channels-depth')

            // AVALIAÇÃO DE ANOTAÇÃO NÃO VAI ENTRAR NA 2.18
            // const LIVE = "live"
            // const DASHBOARD = "dashboard"
            //
            // const evaluationButtonsContainer = ({event}) => <EvaluationButtonsWrapper event={event}/>
            //
            // timelineService.registerAnnotationAction(LIVE, evaluationButtonsContainer)
            // timelineService.registerAnnotationAction(DASHBOARD, evaluationButtonsContainer)
        } catch (e) {
            console.error('Error starting plugin-annotations', e)
        }
    }
}
